<template>
  <div>

      <div class="page-header page-header-small">
        <parallax
          class="page-header-image"
          style="background-image: url('img/concerts-1150042_1920.jpg')"
        >
        </parallax>
        <div class="content-center">
          <div class="container">
            <h1 class="title">Want to know where your customers are?</h1>
          </div>
        </div>
      </div>


      <div class="section section-about-us">

          <div class="container">
            <v-card
              class="mx-auto"
            >
              <v-card-text>
                <div class="row">
                  <div class="col">
                    <CityAutocomplete v-on:childToParent="onChildCityChange"/>
                  </div>
                  <v-divider
                    class="mx-4"
                    vertical
                  ></v-divider>
                  <div class="col">
                      <b-form-group
                        label="Start"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0">
                        <div class="datepicker-container">
                          <fg-input>
                            <el-date-picker
                              type="datetime"
                              popper-class="date-picker date-picker-primary"
                              placeholder="Date Time Picker"
                              v-model="pickers.datePickerStart"
                              v-on:change="datePickerChange"
                            >
                            </el-date-picker>
                          </fg-input>
                        </div>
                      </b-form-group>
                      <b-form-group
                        label="End"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0">
                        <div class="datepicker-container">
                          <fg-input>
                            <el-date-picker
                              type="datetime"
                              popper-class="date-picker date-picker-primary"
                              placeholder="Date Time Picker"
                              v-model="pickers.datePickerEnd"
                              v-on:change="datePickerChange"
                            >
                            </el-date-picker>
                          </fg-input>
                        </div>
                      </b-form-group>
                  </div>
                  <v-divider
                    class="mx-4"
                    vertical
                  ></v-divider>
                  <div class="col">
                    <div class="form-check">
                      <label for="d21c2a66e6c4c" class="form-check-label">
                        <input id="d21c2a66e6c4c" v-model="switches.defaultOn"  type="checkbox" class="form-check-input">
                        <span class="form-check-sign"></span>Active events only
                      </label>
                    </div>
                  </div>
                </div>

              </v-card-text>
            </v-card>
            <div id="alertDiv" class="alertDivStyle" style="padding-top:20px;">
              <v-app>
                <v-alert
                  text
                  dismissible
                  type="info"
                  @input="closeAlert"
                >
                  Notice: Due to COVID-19, many events have been cancelled. It is up to the promoter whether and when an event will be rescheduled or cancelled. We do our best to keep the event status updated but we are dependent on the promotor decisions. In addition the predicted participants might be different.
                </v-alert>
              </v-app>
            </div>
          </div>






          <div class="container">
              <div class="row">
                <div class="col-12 col-md-4 overflow-auto no-float" style="height:100%" v-sticky="{topSpacing:50, bottomSpacing:20}">
                  <v-app>
                  <v-progress-linear
                    color="#C51162"
                    indeterminate
                    rounded
                    height="6"
                    :active=this.showLoader
                  ></v-progress-linear>
                    <div v-for="event in selectedEvents" v-bind:key="event.id">
                      <div style="padding-bottom:20px">
                        <v-card
                          class="mx-auto"
                          color="#26c6da"
                          dark
                        >
                          <v-card-text class="headline font-weight-bold">
                            {{event.start_date}} - <br>{{event.end_date}}*
                          </v-card-text>
                          <p class="headline font-weight-bold listEntry">
                            {{event.title}}
                            <v-icon v-if="event.state == 'cancelled'" color="red" style="vertical-align:baseline">mdi-alpha-x-circle</v-icon>
                            <v-icon v-if="event.state == 'active'" color="green" style="vertical-align:baseline">mdi-checkbox-marked-circle</v-icon>
                          </p>

                          <p class="headline font-weight-light listEntry" style="vertical-align:baseline">
                            <i class="now-ui-icons location_pin"></i> {{event.location.name}}
                          </p>
                          <p class="headline font-weight-light listEntry">
                            <i class="now-ui-icons files_single-copy-04"></i> {{event.category}}
                          </p>
                          <p v-if="event.predicted_participants!=null" class="headline font-weight-light listEntry">
                            <i class="now-ui-icons users_single-02"></i> {{event.predicted_participants}}
                          </p>
                          <p class=" font-weight-light listEntry" style="font-size: 1.00 rem; text-align:right; padding-right: 10px ">
                                <v-icon>mdi-timelapse</v-icon><span> {{event.updated}}</span>
                          </p>
                        </v-card>
                      </div>
                    </div>
                  </v-app>


                  <!-- Main table element
                  <b-table
                    show-empty
                    small
                    stacked="md"
                    :items="selectedEvents"
                    :fields="fields_complex"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    style="marginTop:50px"
                    class="eventtable"
                  >
                    <template v-slot:cell(name)="row">
                      {{ row.value.first }} {{ row.value.last }}
                    </template>

                    <template v-slot:cell(actions)="row">
                      <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                        Info modal
                      </b-button>
                      <b-button size="sm" @click="row.toggleDetails">
                        {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                      </b-button>
                    </template>

                    <template v-slot:row-details="row">
                      <b-card>
                        <ul>
                          <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                        </ul>
                      </b-card>
                    </template>
                  </b-table>

                -->

                </div>
                <div class="col-12 col-md-8">
                  <div v-vue-sticky-directive="{topSpacing:50, bottomSpacing:20}">
                    <!--Event Map-->
                    <v-map ref="myMap2" style="min-height:1000px" :zoom="zoom" :center="center">
                      <v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>
                      <v-marker-cluster :options="clusterOptions">
                      <v-circle v-for="post in selectedEvents"
                        :key="post.id"
                        :lat-lng="[post.location.coordinates[1], post.location.coordinates[0]]"
                        :radius=100
                      >
                        <v-popup>
                        <div>
                          <b>Location:</b> {{post.location.name}} <br>
                          <b>Event:</b> {{post.title}} <br>
                          <b>Start date:</b> {{post.start_date}}
                        </div>

                        </v-popup>
                      </v-circle>
                      </v-marker-cluster>
                    </v-map>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-12 ml-auto mr-auto text-center">
                  <button type="button" id="previous_page_button" class="btn btn-icon btn-round btn-primary" v-on:click="previousPage"><!----><i class="now-ui-icons arrows-1_minimal-left"></i><!----></button>
                  <button type="button" id="next_page_button" class="btn btn-icon btn-round btn-primary" v-on:click="nextPage"><!----><i class="now-ui-icons arrows-1_minimal-right"></i><!----></button>
                </div>
              </div>
              <div class="separator separator-primary"></div>
              * predicted end date
              <div class="section-story-overview">
                <div class="row">
                </div>
              </div>
          </div><!-- end: container -->

      </div><!--end: section section-about-us -->
  </div><!--end:root div -->
</template>
<script>

import { Auth } from 'aws-amplify'
import { Button, FormGroupInput, Switch, Checkbox } from '@/components';
import EventsApi from '@/services/api/Events'

import * as Vue2Leaflet from 'vue2-leaflet'
import { latLng, TimeDimension, Icon, icon, CircleMarker, Marker} from 'leaflet';
import * as L from 'leaflet';
import {LMap, LTileLayer, LMarker, LCircle, LPopup, LControl, LGeoJson, LIconDefault } from 'vue2-leaflet';
import { Popover, Tooltip, DatePicker } from 'element-ui';
import Vue2LeafletMarkercluster from './Vue2LeafletMarkercluster'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

import { Datetime } from 'vue-datetime';

import CityAutocomplete from './components/CityAutocomplete';

import VueStickyDirective from "@renatodeleao/vue-sticky-directive";

function rand(n) {
    let max = n + 0.1
    let min = n - 0.1
    return Math.random() * (max - min) + min;
}



export default {
  name: 'explorer',
  directives: {
    VueStickyDirective
  },
  bodyClass: 'explorer-page',
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [FormGroupInput.name]: FormGroupInput,
    [DatePicker.name]: DatePicker,
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    LPopup,
    LControl,
    //TimeDimension,
    LGeoJson,
    'v-map': Vue2Leaflet.LMap,
    'v-tilelayer': Vue2Leaflet.LTileLayer,
    'v-icondefault': Vue2Leaflet.LIconDefault,
    'v-marker': Vue2Leaflet.LMarker,
    'v-popup': Vue2Leaflet.LPopup,
    'v-circle': Vue2Leaflet.LCircle,
    'v-circle-marker': Vue2Leaflet.LCircleMarker,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    'v-control': Vue2Leaflet.LControl,
    [Switch.name]: Switch,
    'datetime': Datetime,
    CityAutocomplete

  },
  data() {

    return {
      clusterOptions: { disableClusteringAtZoom: 13 },
      //initialLocation: latLng(53.556101, 9.7877407),




      fromChild: '',

    // Event Map
        loading: true,
        allEvents:[],
        selectedEvents:[],
        zoom: 10,
        center: latLng(53.556101, 9.7877407),
        url:'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

    // Both Tables
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        pageOptions: [20, 50, 100],
        sortBy: 'start_date',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },

        pickers: {
          datePickerStart: null,
          datePickerEnd: null
        },
        currentLocation:{
          lat: 53.5584902,
          lng: 9.787740
        },
        next_token: null,
        previous_token: null,





    // Complex Table
        fields_complex: [
          { key: 'start_date', label: 'Start', sortable: true, sortDirection: 'desc' },
          { key: 'end_date', label: 'End*', sortable: true, class: 'text-center' },
          { key: 'title', label: 'Title', sortable: true, class: 'text-center' },
          { key: 'location.name', label: 'Location', sortable: true, class: 'text-center' },
          { key: 'category', label: 'Category', sortable: true, class: 'text-center' },
          { key: 'state', label: 'State', sortable: true, class: 'text-center' },
          { key: 'updated', label: 'Updated', sortable: true, class: 'text-center' },
          { key: 'predicted_participants', label: 'PredictedParticipants', sortable: true, class: 'text-center' }
        ],


        switches: {
          defaultOn: true,
          defaultOff: false
        },
        cityRadius: null,
        showLoader:false

    };
  },
  computed: {
      sortOptions() {
          // Create an options list from our fields
          return this.fields
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key }
            })
      },
      activeEvents: function() {
        var events = this.allEvents;
        var activeEvents =  events.filter(function(event) {
        	return event.state == "active";
        });
        return activeEvents;
    }



  },
  mounted() {

    setTimeout(() => {
          console.log('done')
          this.$nextTick(() =>{
            this.clusterOptions = { disableClusteringAtZoom: 13 }
          });
        }, 5000);

    window.scrollTo(0, 0)

    let recaptchaScript2 = document.createElement('script')
    recaptchaScript2.setAttribute('src', 'https://cdn.jsdelivr.net/npm/iso8601-js-period@0.2.1/iso8601.min.js')
    document.head.appendChild(recaptchaScript2)

    // Complex Table
    //this.totalRows = this.allEvents.length;


    // Map
    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
    this.$nextTick(() => {
      this.eventmap = this.$refs.myMap2.mapObject // work as expected

      var legend = L.control({position: 'bottomright'});
      legend.onAdd = function (map) {

          var div = L.DomUtil.create('div', 'info legend'),
            grades = ["Car", "ball"],
            labels = ["http://datentaeter.de/wp-content/uploads/2016/06/flag_de.png","http://datentaeter.de/wp-content/uploads/2016/06/flag_de.png"];

              div.innerHTML ='<b>Legend:</b><br>'
                + (" <img src='img/legend_blue_circle.png' height='15'>") +' = represents one event<br>'
                + (" <img src='img/legend_cluster.png' height='15'>") +' = represents an event cluster<br>';

          return div;
      };

      legend.addTo(this.eventmap);

    })
  },
  methods: {

    click: (e) => console.log("clusterclick", e),
    ready: (e) => console.log('ready', e),
    // Complex Table
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(allEvents) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = allEvents.length
        this.currentPage = 1
      },

      closeAlert(v){
        document.getElementById('alertDiv').style.display = 'none';
      },

      nextPage: function (event) {
        EventsApi.getNextPage(this.next_token, 20, this.jwt)
          .then(allEvents => {
            this.allEvents = allEvents.data
            this.totalRows = this.allEvents.length;
            if(allEvents.next_token){
              this.next_token = allEvents.next_token;
              const button = document.getElementById('next_page_button');
              button.disabled = false;
            }else{
              const button = document.getElementById('next_page_button');
              button.disabled = true;
            }
            if(allEvents.previous_token){
              this.previous_token = allEvents.previous_token;
              const button = document.getElementById('previous_page_button');
              button.disabled = false;
            }else{
              const button = document.getElementById('previous_page_button');
              button.disabled = true;
            }

          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loading = false
          })

      },
      previousPage: function (event) {
        EventsApi.getPreviousPage(this.previous_token, 20, this.jwt)
          .then(allEvents => {
            this.allEvents = allEvents.data
            this.totalRows = this.allEvents.length;
            if(allEvents.next_token){
              this.next_token = allEvents.next_token;
              const button = document.getElementById('next_page_button');
              button.disabled = false;
            }else{
              const button = document.getElementById('next_page_button');
              button.disabled = true;
            }
            if(allEvents.previous_token){
              this.previous_token = allEvents.previous_token;
              const button = document.getElementById('previous_page_button');
              button.disabled = false;
            }else{
              const button = document.getElementById('previous_page_button');
              button.disabled = true;
            }

          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loading = false
          })

      },
      onChange: function(data) {

      },

      datePickerChange(evt){
        if (this.pickers.datePickerStart!=null && this.pickers.datePickerEnd !=null){
          this.queryEventData(this.currentLocation.lat,this.currentLocation.lng,10000,this.pickers.datePickerStart,this.pickers.datePickerEnd, 20, (this.switches.defaultOn) ? "active" : undefined)
        }
      },
      onChildCityChange (value) {
        this.showLoader=true;
        this.fromChild = value
        var latlng = L.latLng(value.lat, value.lng);
        this.center = latlng
        this.currentLocation.lat = value.lat
        this.currentLocation.lng = value.lng
        this.queryEventData(this.currentLocation.lat,this.currentLocation.lng,10000,this.pickers.datePickerStart,this.pickers.datePickerEnd, 20, (this.switches.defaultOn) ? "active" : undefined)
      },


      queryEventData (lat,lng,radius, start, end, limit, state) {
        Auth.currentSession().then(res=>{
          let accessToken = res.getAccessToken()
          this.jwt = accessToken.getJwtToken()

          EventsApi.getEvents(lat,lng,radius, start, end, limit, state, this.jwt)
            .then(allEvents => {

              this.showLoader = false;
              this.allEvents = allEvents.data
              this.totalRows = this.allEvents.length

              if(allEvents.next_token){
                this.next_token = allEvents.next_token;
                const button = document.getElementById('next_page_button');
                button.disabled = false;
              }else{
                const button = document.getElementById('next_page_button');
                button.disabled = true;
              }
              if(allEvents.previous_token){
                this.previous_token = allEvents.previous_token;
                const button = document.getElementById('previous_page_button');
                button.disabled = false;
              }else{
                const button = document.getElementById('previous_page_button');
                button.disabled = true;
              }
            })

            .catch(error => console.log(error))
            .finally(() => {
              this.loading = false
            })



        })





      }






  },
  watch: {
      allEvents: function(val) {
          //do something when the data changes.
          if (val) {
          }

      },
      'currentLocation.lat': {
        handler: function (val, oldVal) {
          var map = this.$refs.myMap2.mapObject
          if(this.cityRadius!=null)map.removeLayer(this.cityRadius)
          this.cityRadius = L.circle([this.currentLocation.lat,this.currentLocation.lng], {
              color: "#028090",
              fillOpacity: 0.05,
              radius: 10000.0
          }).addTo(map);
        }
      },



      // once activeEvents are calculated, the selectedEvents are overwritten with activeEvents
      activeEvents: function(val){
        if(this.switches.defaultOn){
          this.selectedEvents = this.activeEvents
          this.totalRows = this.selectedEvents.length
        }else{
          this.selectedEvents = this.allEvents
          this.totalRows = this.selectedEvents.length;
        }

      },

      // once the toggle "active events" is switched, selectedEvents are overwritten with allEvents or with activeEvents
      'switches.defaultOn': {
        handler: function (val, oldVal) {

            this.queryEventData(this.currentLocation.lat,this.currentLocation.lng,10000,this.pickers.datePickerStart,this.pickers.datePickerEnd, 20, (this.switches.defaultOn) ? "active" : undefined)
            this.selectedEvents = this.activeEvents
            this.totalRows = this.selectedEvents.length;


        }
      }
  },
  created(){

    this.showLoader=true;

    Auth.currentSession().then(res=>{
      let accessToken = res.getAccessToken()
      this.jwt = accessToken.getJwtToken()

    })
    const currentDate = new Date();
    currentDate.setSeconds(0,0);

    const calculatedEndDate = new Date(currentDate);
    calculatedEndDate.setDate(calculatedEndDate.getDate()+14)
    calculatedEndDate.toISOString().substring(0, 10);

    this.pickers.datePickerStart = currentDate
    this.pickers.datePickerEnd = calculatedEndDate


    //this.queryEventData(this.currentLocation.lat,this.currentLocation.lng,19002,this.pickers.datePickerStart,this.pickers.datePickerEnd, 20)

  // Map




  }
};
</script>
<style>
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  .circle {
    background: #0000ff; /* color of the circle */
    border-radius: 50%; /* make the div a circular shape */
    box-shadow: 4px 4px 3px grey; /* see http://www.w3schools.com/css/css3_shadows.asp */
    -moz-box-shadow: 4px 4px 3px grey;
    -webkit-box-shadow: 4px 4px 3px grey;
  }

  .legend {
    background: rgba(255,255,255, 0.8);
    width: 200px;
    text-align:left;
  }
  .eventtable {
    line-height: 30px;
  }

  .verticalScrollable {
    position: absolute;
    overflow-y: scroll;
  }

  .listEntry {
    font-size: 1.25rem;
    padding-left: 16px;
  }





  [data-v-sticky-container]{
    position: relative;
    height: 3000px;
    display: flex;
    outline: 1px solid black;
  }

  .sticky{
    width:400px;

    >*{
      background: black;
      color: white;
      padding: 80px;
    }


    &.is-affixed{
      >* {
        box-shadow: 2px 4px 8px rgba(0,0,0,0.12);
      }
    }
  }

  .sticky-local{
    >* {
      background: whitesmoke;
      color: black;
    }
  }

  div.alertDivStyle * {
      min-height:1vh;
  }



</style>
